/* eslint-disable*/
import $ from 'jquery';

window.dataLayer = window.dataLayer || [];

const $sliderButton = $('.slide-item').find('.js-dl-slide');
const $rgButton = $('.cw-featurette-b').find('.js-dl-slide');
const $navButtons = $('.c-desktop-menu').find('.js-nav-item');

// Store datalayer variables for both hp donate form slider item button and RG button click.
function storeHPDataLayerVariables(e) {
    e.preventDefault();
    const id = $(this).attr('id');
    const href = $(this).attr('href');
    dataLayer.push({ 'HomepageAction': id });
    window.location = href;
}

// Store datalayer variables for 2 nav items; Become a monthly giver and Make a single donation.
function storeNavDataLayerVariables(e) {
    e.preventDefault();
    const id = $(this).attr('id');
    const href = $(this).attr('href');
    dataLayer.push({ 'NavAction': id });
    window.location = href;
}

$sliderButton.on('click', storeHPDataLayerVariables);
$rgButton.on('click', storeHPDataLayerVariables);
$navButtons.on('click', storeNavDataLayerVariables);



// WEBPACK FOOTER //
// ./src/js/datalayer-variables.js